import CoursePicture from "../coursePicture/CoursePicture";
import NavigateLink from "../../navigateLink/navigateLink";
import Tooltip from "../../../ui/tooltip/Tooltip";
import gaSectionType from "../../../../enums/gaSectionType";
import classes from "./MyCourseItem.module.css";

const MyCourseItem = ({ course}) => {

    return (
            <NavigateLink link={course.link} ga={{ section: gaSectionType.sg, sectionValue: course?.domain }}>
                <div className={classes.CourseItem}>
                    <div className={classes.CourseIcon}>
                        <CoursePicture
                            picture={course.picture}
                            courseId={course.externalId}
                            course={course}
                        />
                    </div>
                    <div className={classes.Course}>
                        <Tooltip text={course.name} showTooltip={true}>
                            <p className={classes.CourseName}>{course?.name}</p>
                        </Tooltip>
                    </div>
                </div>
            </NavigateLink>
    );
};

export default MyCourseItem; 